import { ICellRendererParams } from 'ag-grid-community';

import { PartDescription } from 'bom/components';
import { Loader } from 'core/elements';
import { useAgGridCellUpdateContext } from 'core/states';
import { getAgGridTableCellData } from 'core/utils';
import { Size } from 'theme/enums';

export const DescriptionCell = (props: ICellRendererParams) => {
  const { isUpdating } = useAgGridCellUpdateContext();

  const data = getAgGridTableCellData(props, 'description');

  if (!data) {
    return props?.value;
  }

  if (isUpdating(props.node.id, 'description')) {
    return <Loader size={Size.SM} style={{ textAlign: 'inherit', margin: 0, display: 'block' }} />;
  }

  return <PartDescription bomPart={data} />;
};
